<template>
  <BaseDialog
    centered
    v-show="modelVoteReason !== null"
    contentClass="delete-go-nogo-reason"
    ref="dialog"
    :show-actions="true"
  >
    <template slot="title">
      {{ $t('page.admin-go-nogo.delete-dialog-title') }}
    </template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div class="delete-go-nogo-reason__current-reason">
          <span class="delete-go-nogo-reason__current-reason-text">
            {{ $t('page.admin-go-nogo.delete-dialog-are-you-sure') }}
          </span>
        </div>
        <div class="delete-go-nogo-reason__actions">
          <FormButton is-outlined class="delete-go-nogo-reason__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton @click.native="onSubmit" type="submit">
            <span>{{ $t('actions.confirm') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DeleteGoNoGoReasonDialog',
  components: {
    FormButton,
    BaseDialog,
  },
  data() {
    return {
      id: null,
      modelVoteReason: null,
    };
  },
  computed: {
    ...mapGetters('goNoGo', ['pending']),
  },
  methods: {
    ...mapActions('goNoGo', ['deleteOpportunityVoteReason']),
    openDialog(item) {
      this.id = item.id;
      this.modelVoteReason = item;
      this.$nextTick(() => {
        this.$refs.dialog.openModal();
      });
    },
    closeDialog() {
      if (this.$refs.dialog) {
        this.$refs.dialog.isModalOpen = false;
      }
    },
    onSubmit() {
      this.deleteOpportunityVoteReason(this.id)
        .then(() => {
          this.$toast.success(this.$t('page.admin-go-nogo.actions.success-delete'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    cancelClick() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-go-nogo-reason {
  height: auto;
  width: 800px;
  position: relative;
  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }
  .close-icon__container {
    display: none;
  }
}
.delete-go-nogo-reason {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }
  &__cancel {
    margin-right: 12px;
  }
  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
  &__current-reason {
    display: flex;
    flex-direction: column;
    gap: 8px;
    &-text {
      color: $color-normal;
    }
  }
  &__warning-notice {
    margin: 32px 0 16px 0;
    font-size: 14px;
    background: $color-red-100;
    padding: 8px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 16px;
    &-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 16px;
      span:first-child {
        font-weight: 700;
      }
    }
  }
  &__alert-icon {
    width: 24px;
    height: 24px;
    color: $color-error;
  }
}
</style>
